<template>
  <div
    class="d-flex align-items-center flex-grow-0"
    data-cy="back-button-container"
  >
    <h4
      class="btn-custom-text-color font-weight-bold my-0 mr-4"
      data-cy="back-button-title"
    >
      <font-awesome-layers
        class="fa-lg back-button"
        @click="goBack"
        data-cy="btn-back"
      >
        <font-awesome-icon
          :icon="['far', 'circle']"
          data-cy="icon-back-circle"
        />
        <font-awesome-icon
          icon="arrow-left"
          transform="shrink-6"
          data-cy="icon-back-arrow"
        />
      </font-awesome-layers>
    </h4>
  </div>
</template>

<script>
export default {
  name: "back-button",
  methods: {
    async goBack() {
      await this.$store.dispatch("setGoBack", true);

      this.$router.push(this.$store.getters.from);
    }
  }
};
</script>

<style>
.back-button {
  cursor: pointer;
}
</style>
